import { useQuery } from "@tanstack/react-query";
import {
  OpenDataTypeEnum,
  type OpenDataClient,
} from "../features/api/openData";
import { I18nUtil } from "../utils";
import { QUERY_KEYS } from "../config/constant";
import { useOspApiClientProvider } from "./useOspApiClientProvider";

export const useSearchGroup = ({
  keywords,
  type,
  queryTypes,
  market,
  category,
}: {
  keywords: string;
  type?: "normal" | "portfolio";
  queryTypes?: OpenDataTypeEnum[];
  category?: string;
  market?: string;
}) => {
  const { openDataApi } = useOspApiClientProvider();
  const locale = I18nUtil.getCurrentLocale();
  I18nUtil.getBackgroundLanguageKey(locale);

  const defaultTypes =
    type === "normal"
      ? [
          OpenDataTypeEnum.TOKEN,
          OpenDataTypeEnum.CONTENT,
          OpenDataTypeEnum.STOCK,
          OpenDataTypeEnum.THEME,
        ].filter((t): t is OpenDataTypeEnum => t !== undefined)
      : [OpenDataTypeEnum.TOKEN, OpenDataTypeEnum.STOCK];

  // 如果外部显式传入了 queryTypes（即使是空数组），就使用外部传入的；
  // 只有在未传入（undefined）时才使用默认逻辑
  const types = queryTypes ?? defaultTypes;
  const { data, isFetching, isPending, error } = useQuery({
    queryKey: [
      QUERY_KEYS.SEARCH_GROUP,
      keywords,
      locale,
      types,
      market,
      category,
    ],
    enabled: !!openDataApi && !!keywords && keywords.trim() !== "",
    queryFn: async () => {
      const searchRequest: NonNullable<
        Parameters<OpenDataClient<unknown>["searchGrouped"]["searchGrouped"]>[0]
      > = {
        keyword: keywords,
        types,
        operator: "MATCH",
        limit: 20,
        language: I18nUtil.getBackgroundLanguageKey(locale),
        market,
      };
      const res = await openDataApi!.searchGrouped.searchGrouped(
        searchRequest,
        {},
      );
      if (res.data.data) {
        return res.data.data;
      }
      return [];
    },
  });
  return {
    data,
    isLoading: isPending || isFetching,
    error,
  };
};
